import Logs from "./Logs-compose";

export default Logs;
